import type { EventStatus } from '@/types/domain';
import { cn } from '@/utils/cn';

interface EventStatusBadgeProps {
  status: EventStatus;
  size?: 'sm' | 'md';
}

const statusLabelMap: Record<EventStatus, string> = {
  draft: 'Draft',
  upcoming: 'Upcoming',
  open: 'Open',
  closed: 'Closed',
  archived: 'Archived',
  cancelled: 'Cancelled',
};

export function EventStatusBadge({ status, size = 'md' }: EventStatusBadgeProps): JSX.Element {
  return (
    <span className={cn('event-status-badge', `event-status-badge--${status}`, `event-status-badge--${size}`)}>
      <span className="event-status-badge__dot" aria-hidden="true" />
      {statusLabelMap[status]}
    </span>
  );
}
